import { render } from "./ListeCommunePage.vue?vue&type=template&id=036d671c&ts=true"
import script from "./ListeCommunePage.vue?vue&type=script&lang=ts"
export * from "./ListeCommunePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__